import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectDataMatchId, selectDataUser } from 'connect/selectors';

import { useHookResult } from 'pages/funnel/storage/hooks';

import { useOfferService } from './OfferService';

class AnalyticsService {
  constructor({ offerService, user, matchId }) {
    this._offerService = offerService;
    this._user = user;
    this._matchId = matchId;
  }

  get analyticsData() {
    return {
      userId: this._user?.id,
      matchId: this._matchId,
      offerName: this._offerService.offerName,
      offerValue: this._offerService.offerValue,
      offerType: this._offerService.offerType,
    };
  }
}

export const useAnalyticsService = () => {
  const offerService = useOfferService();

  const user = useSelector(selectDataUser);
  const matchId = useSelector(selectDataMatchId);

  const createServiceParams = useCallback(() => ({
    offerService,
    user,
    matchId,
  }), [offerService, user, matchId]);

  const createService = useCallback(() => new AnalyticsService(createServiceParams()), [createServiceParams]);

  return useHookResult(createService);
};
